import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * Preserve Travel snowflake IDs that exceed Number.MAX_SAFE_INTEGER.
 * Owner management API only — not the anonymous public journey GET.
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:publicationId|journeyId|ownerMemberId|creatorMemberId|memberId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

function confirmBody(expectedRowVersion, confirm = true) {
  return {
    expectedRowVersion,
    confirm,
  };
}

/** Private JourneyPublication management — OWNER mutations; GET may be readable by ACTIVE members. */
export const journeyPublicationApi = {
  getByJourney: (journeyId) => travelClient.get(
    travelEndpoints.journeyPublication(journeyId),
    snowflakeJson,
  ),
  createDraft: (journeyId) => travelClient.post(
    travelEndpoints.journeyPublication(journeyId),
    undefined,
    snowflakeJson,
  ),
  changeVisibility: (journeyId, { visibility, expectedRowVersion, confirm = true }) => travelClient.post(
    travelEndpoints.journeyPublicationVisibility(journeyId),
    { visibility, expectedRowVersion, confirm },
    snowflakeJson,
  ),
  changeCopyPermission: (journeyId, { allowCopy, expectedRowVersion, confirm = true }) => travelClient.post(
    travelEndpoints.journeyPublicationCopyPermission(journeyId),
    { allowCopy, expectedRowVersion, confirm },
    snowflakeJson,
  ),
  changePromotionPermission: (journeyId, { allowPromotion, expectedRowVersion, confirm = true }) => travelClient.post(
    travelEndpoints.journeyPublicationPromotionPermission(journeyId),
    { allowPromotion, expectedRowVersion, confirm },
    snowflakeJson,
  ),
  publish: (journeyId, { expectedRowVersion, confirm = true }) => travelClient.post(
    travelEndpoints.journeyPublicationPublish(journeyId),
    confirmBody(expectedRowVersion, confirm),
    snowflakeJson,
  ),
  unpublish: (journeyId, { expectedRowVersion, confirm = true }) => travelClient.post(
    travelEndpoints.journeyPublicationUnpublish(journeyId),
    confirmBody(expectedRowVersion, confirm),
    snowflakeJson,
  ),
  refresh: (journeyId, {
    expectedJourneyRowVersion,
    expectedItineraryRowVersion,
    expectedPublicationRowVersion,
    expectedStoryRevision,
    confirm = true,
  }) => travelClient.post(
    travelEndpoints.journeyPublicationRefresh(journeyId),
    {
      expectedJourneyRowVersion,
      expectedItineraryRowVersion,
      expectedPublicationRowVersion,
      ...(Number.isInteger(expectedStoryRevision) && expectedStoryRevision >= 0
        ? { expectedStoryRevision }
        : {}),
      confirm,
    },
    snowflakeJson,
  ),
};
